module.exports = __webpack_public_path__ + "img/hotel1_3.eba9dd8d.png";